import { render } from "./UniqueIds.vue?vue&type=template&id=a6ecc230&scoped=true"
import script from "./UniqueIds.vue?vue&type=script&lang=js"
export * from "./UniqueIds.vue?vue&type=script&lang=js"

import "./UniqueIds.vue?vue&type=style&index=0&id=a6ecc230&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ecc230"]])

export default __exports__